/**
 * useCompanyData Hook
 *
 * React Query hooks for company data.
 */

import { useQuery } from '@tanstack/react-query';
import { CompanyService } from '../services/companyService';

const companyKeys = {
  all: ['company'] as const,
  detail: () => [...companyKeys.all, 'detail'] as const,
};

export function useCompany(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: companyKeys.detail(),
    queryFn: () => CompanyService.getCompany(),
    enabled: options?.enabled,
  });
}


